var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"pt-5"},[_c('Loader',{staticClass:"mt-5"})],1):_c('CampPreview',{attrs:{"previewData":_vm.dataFromFirebase}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }